import { createContext } from "react";
import { DropzoneRootProps } from "react-dropzone";

interface UploadContextValue {
  open: () => void;
  isDragging?: boolean;
  getDraggerProps?: (props?: DropzoneRootProps) => DropzoneRootProps;
}

export const UploadContext = createContext<UploadContextValue>({
  open: () => {},
  isDragging: false,
  getDraggerProps: () => ({}),
});
